<div class="mesclagem-contatos">
  <div class="mesclagem-contatos__cabecalho">
    <div>
      <h4>Mesclar contatos</h4>
      <p class="text-muted mb-0">O contato principal continuará em uso. O contato de origem deixará de acessar a conta.</p>
    </div>
    <button type="button" class="btn btn-link" (click)="feche()" [disabled]="mesclando" aria-label="Fechar">Fechar</button>
  </div>

  <div class="mesclagem-contatos__selecao">
    <div class="mesclagem-contatos__principal">
      <strong>Contato principal — permanece</strong>
      <span>{{principal?.nome || 'Sem nome'}} · {{principal?.codigoPais || ''}} {{principal?.telefone || 'Sem telefone'}}</span>
    </div>
    <div>
      <label for="origem-mesclagem">Contato de origem — será desativado</label>
      <kendo-combobox id="origem-mesclagem" [data]="candidatos" [ngModel]="origem"
        [textField]="'nome'" [valueField]="'id'" [filterable]="true" [allowCustom]="false"
        [clearButton]="true" [loading]="buscando" [disabled]="mesclando"
        (filterChange)="busqueCandidatos($event)" (valueChange)="selecioneOrigem($event)"
        placeholder="Busque por nome ou telefone">
        <ng-template kendoComboBoxItemTemplate let-contato>
          {{contato.nome || 'Sem nome'}} · {{contato.codigoPais || ''}} {{contato.telefone || 'Sem telefone'}}
        </ng-template>
        <ng-template kendoComboBoxNoDataTemplate>Nenhum contato encontrado.</ng-template>
      </kendo-combobox>
      <p class="text-muted mt-2 mb-0" *ngIf="origem">Origem selecionada: {{origem.nome || 'Sem nome'}} · {{origem.codigoPais || ''}} {{origem.telefone || 'Sem telefone'}}</p>
    </div>
  </div>

  <p *ngIf="erroBusca" class="alert alert-danger mt-3" role="alert">{{erroBusca}}</p>
  <p *ngIf="carregandoPrevia" class="text-muted mt-3" role="status">Carregando prévia da mesclagem…</p>
  <div *ngIf="erroPrevia" class="alert alert-danger mt-3" role="alert">
    {{erroPrevia}}
    <button type="button" class="btn btn-link p-0 ml-2" (click)="carreguePrevia()">Tentar novamente</button>
  </div>

  <div *ngIf="previa" class="mesclagem-contatos__previa">
    <h5>Confira antes de mesclar</h5>
    <div class="table-responsive">
      <table class="table table-sm table-bordered">
        <thead><tr><th>Informação</th><th>Principal</th><th>Origem</th><th>Resultado</th></tr></thead>
        <tbody>
          <tr><th>Nome</th><td>{{previa.principal?.nome || '—'}}</td><td>{{previa.origem?.nome || '—'}}</td><td>{{previa.principal?.nome || previa.origem?.nome || '—'}}</td></tr>
          <tr><th>Telefone</th><td>{{previa.principal?.codigoPais || ''}} {{previa.principal?.telefone || '—'}}</td><td>{{previa.origem?.codigoPais || ''}} {{previa.origem?.telefone || '—'}}</td><td>Telefone do principal</td></tr>
          <tr><th>CPF</th><td>{{previa.principal?.cpf || '—'}}</td><td>{{previa.origem?.cpf || '—'}}</td><td>{{previa.principal?.cpf || previa.origem?.cpf || '—'}}</td></tr>
          <tr><th>CNPJ</th><td>{{previa.principal?.cnpj || '—'}}</td><td>{{previa.origem?.cnpj || '—'}}</td><td>{{previa.principal?.cnpj || previa.origem?.cnpj || '—'}}</td></tr>
          <tr><th>E-mail</th><td>{{previa.principal?.email || '—'}}</td><td>{{previa.origem?.email || '—'}}</td><td>{{previa.principal?.email || '—'}}</td></tr>
          <tr><th>Pedidos</th><td>{{previa.principal?.qtdePedidos || 0}}</td><td>{{previa.origem?.qtdePedidos || 0}}</td><td><strong>{{previa.resultado?.qtdePedidos || 0}}</strong></td></tr>
          <tr><th>Saldo de crédito</th><td>{{(previa.principal?.saldoCredito || 0) | currency:'BRL'}}</td><td>{{(previa.origem?.saldoCredito || 0) | currency:'BRL'}}</td><td><strong>{{(previa.resultado?.saldoCredito || 0) | currency:'BRL'}}</strong></td></tr>
          <tr><th>Saldo de fiado</th><td>{{(previa.principal?.saldoFiado || 0) | currency:'BRL'}}</td><td>{{(previa.origem?.saldoFiado || 0) | currency:'BRL'}}</td><td><strong>{{(previa.resultado?.saldoFiado || 0) | currency:'BRL'}}</strong></td></tr>
        </tbody>
      </table>
    </div>

    <div class="table-responsive" *ngIf="previa.resultado?.pontos?.length">
      <h6>Pontos por plano</h6>
      <table class="table table-sm table-bordered">
        <thead><tr><th>Plano</th><th>Principal</th><th>Origem</th><th>Resultado</th></tr></thead>
        <tbody><tr *ngFor="let plano of previa.resultado.pontos">
          <th>{{plano.nome}}</th>
          <td>{{pontosNoContato(previa.principal, plano.planoId) | number}}</td>
          <td>{{pontosNoContato(previa.origem, plano.planoId) | number}}</td>
          <td><strong>{{plano.pontos | number}}</strong></td>
        </tr></tbody>
      </table>
    </div>
    <div class="mesclagem-contatos__detalhes" *ngIf="previa.resultado?.camposPreenchidos?.length">
      <h6>Campos preenchidos com dados da origem</h6>
      <ul><li *ngFor="let campo of previa.resultado.camposPreenchidos">{{campo.campo}}: <strong>{{campo.valor}}</strong></li></ul>
    </div>
    <div class="alert alert-warning" *ngIf="previa.avisos?.length" role="alert">
      <strong>Avisos</strong>
      <ul class="mb-0"><li *ngFor="let aviso of previa.avisos">{{aviso}}</li></ul>
    </div>
    <div class="alert alert-danger" *ngIf="previa.bloqueios?.length" role="alert">
      <strong>Esta mesclagem está bloqueada</strong>
      <ul class="mb-0"><li *ngFor="let bloqueio of previa.bloqueios">{{bloqueio}}</li></ul>
    </div>
  </div>

  <p *ngIf="erroMesclagem" class="alert alert-danger" role="alert">{{erroMesclagem}}</p>
  <div class="mesclagem-contatos__acoes">
    <button type="button" class="btn btn-outline-secondary" (click)="feche()" [disabled]="mesclando">Cancelar</button>
    <button type="button" class="btn btn-danger" (click)="mescle()" [disabled]="!podeMesclar()">
      {{mesclando ? 'Mesclando…' : 'Mesclar contatos'}}
    </button>
  </div>
</div>
